import { isQsrAdmin } from '@/utils/is_qsr_admin';

/** @typedef {import('vue-router').RouteLocationNormalizedGeneric} RouteLocationNormalizedGeneric */
/** @typedef {import('vue-router').RouteLocationNormalizedLoadedGeneric} RouteLocationNormalizedLoadedGeneric */
/** @typedef {import('vue-router').NavigationGuardNext} NavigationGuardNext */

export const fileManagerRoutes = [
  {
    name: 'FileManager Library',
    path: '/fileManager',
    redirect: '/fileManager/dashboard',
    children: [
      {
        path: '/fileManager/dashboard',
        name: 'My FM Files',
        meta: { id: 'fileManager-dashboard' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_dashboard_display.vue'),
        // ...addPermissionsToRoute(['file_manager_access']),
      },
      {
        path: '/fileManager/dashboardv1',
        name: 'My FM Files V1',
        meta: { id: 'fileManager-dashboard-v1' },
        component: () =>
          import('@/projects/file_manager_v1/ui/pages/fileManagerDashboard.vue'),
      },
      {
        path: '/fileManager/dashboardv2',
        name: 'My FM Files V2',
        meta: { id: 'fileManager-dashboard-v2' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_dashboard.vue'),
      },
      {
        path: '/fileManager/shared',
        name: 'Shared FM Folders',
        meta: { id: 'fileManager-sharedDashboard' },
        component: () =>
          import('@/projects/file_manager_v1/ui/pages/sharedFileManagerDashboard.vue'),
        // ...addPermissionsToRoute(['file_manager_access']),
      },
      {
        path: '/fileManager/shared/:pathname*',
        name: 'Shared FM Folders',
        meta: { id: 'fileManager-sharedDashboard' },
        component: () =>
          import('@/projects/file_manager_v1/ui/pages/sharedFileManagerDashboard.vue'),
        // ...addPermissionsToRoute(['file_manager_access']),
      },
      {
        path: '/fileManager/sharedFolder',
        name: 'Shared FM Folder',
        meta: { id: 'fileManager-sharedFolder' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_shared_folder.vue'),
      },
      {
        path: '/fileManager/sharedFolderAdmin',
        name: ' Shared FM Folder Administration',
        meta: { id: 'fileManager-sharedFolderAdmin' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_shared_folder_admin.vue'),
      },
      {
        path: '/fileManager/debug',
        name: 'FM Debug',
        meta: { id: 'fileManager-debug' },
        component: () => import('@/projects/file_manager/ui/pages/debug.vue'),
        /**
         * @param {RouteLocationNormalizedGeneric} _to The target Route Location Object
         * @param {RouteLocationNormalizedLoadedGeneric} _from The previous route
         * @param {NavigationGuardNext} next The next function to be called to resolve the hook
         */
        beforeEnter(_to, _from, next) {
          if (isQsrAdmin()) {
            next();
            return;
          }
          next({ name: 'timekeeping' });
        },
      },
    ],
  },
  // New Resource Library routes (same functionality, different paths)
  {
    name: 'Resource Library',
    path: '/resourceLibrary',
    redirect: '/resourceLibrary/dashboard',
    children: [
      {
        path: '/resourceLibrary/dashboard',
        name: 'My Files',
        meta: { id: 'resourceLibrary-dashboard' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_dashboard_display.vue'),
        // ...addPermissionsToRoute(['file_manager_access']),
      },
      {
        path: '/resourceLibrary/dashboardv1',
        name: 'My Files V1',
        meta: { id: 'resourceLibrary-dashboard-v1' },
        component: () =>
          import('@/projects/file_manager_v1/ui/pages/fileManagerDashboard.vue'),
      },
      {
        path: '/resourceLibrary/dashboardv2',
        name: 'My Files V2',
        meta: { id: 'resourceLibrary-dashboard-v2' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_dashboard.vue'),
      },
      {
        path: '/resourceLibrary/shared',
        name: 'Shared Folders',
        meta: { id: 'resourceLibrary-sharedDashboard' },
        component: () =>
          import('@/projects/file_manager_v1/ui/pages/sharedFileManagerDashboard.vue'),
        // ...addPermissionsToRoute(['file_manager_access']),
      },
      {
        path: '/resourceLibrary/shared/:pathname*',
        name: 'Shared Folders',
        meta: { id: 'resourceLibrary-sharedDashboard' },
        component: () =>
          import('@/projects/file_manager_v1/ui/pages/sharedFileManagerDashboard.vue'),
        // ...addPermissionsToRoute(['file_manager_access']),
      },
      {
        path: '/resourceLibrary/sharedFile',
        name: 'Shared File',
        meta: { id: 'resourceLibrary-sharedFile' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_shared_file.vue'),
      },
      {
        path: '/resourceLibrary/sharedFolder',
        name: 'Shared Folder',
        meta: { id: 'resourceLibrary-sharedFolder' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_shared_folder.vue'),
      },
      {
        path: '/resourceLibrary/sharedFolderAdmin',
        name: 'Shared Folder Administration',
        meta: { id: 'resourceLibrary-sharedFolderAdmin' },
        component: () =>
          import('@/projects/file_manager/ui/pages/file_manager_shared_folder_admin.vue'),
      },
      {
        path: '/resourceLibrary/debug',
        name: 'Debug',
        meta: { id: 'resourceLibrary-debug' },
        component: () => import('@/projects/file_manager/ui/pages/debug.vue'),
        /**
         * @param {RouteLocationNormalizedGeneric} _to The target Route Location Object
         * @param {RouteLocationNormalizedLoadedGeneric} _from The previous route
         * @param {NavigationGuardNext} next The next function to be called to resolve the hook
         */
        beforeEnter(_to, _from, next) {
          if (isQsrAdmin()) {
            next();
            return;
          }
          next({ name: 'timekeeping' });
        },
      },
    ],
  },
];

export const fileManagerPublicRoutes = [
  {
    path: '/fileManager/sharedFolder',
  },
  // Add resourceLibrary public route for backwards compatibility
  {
    path: '/resourceLibrary/sharedFolder',
  },
];
